import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { TP_ACCOUNTS_ROUTE_PATHS } from './config';

export const TP_ACCOUNTS_ROUTES: TApplicationRoute[] = [
  {
    id: 'users-tp-accounts',
    path: TP_ACCOUNTS_ROUTE_PATHS.tpAccounts,
    component: lazy(() => import('./pages/tp-accounts-page')),
    layout: 'default',
    permissions: { scopes: ['users-tp-accounts'] },
    menu: {
      title: 'Transfer Platform Accounts',
    },
  },
];
